import { useCallback } from "react";

import { hasSettingsChanges } from "../utils/systemSettingUtils";

export function useSettingsDirtyState(methods, initialData) {
  const formValues = methods.watch();

  const hasChanges = useCallback(() => {
    return hasSettingsChanges(formValues, initialData);
  }, [formValues, initialData]);

  return {
    formValues,
    hasChanges,
  };
}
